import { render, staticRenderFns } from "./SettingMedia.vue?vue&type=template&id=c4f8cab0&scoped=true&"
import script from "./SettingMedia.vue?vue&type=script&lang=js&"
export * from "./SettingMedia.vue?vue&type=script&lang=js&"
import style0 from "./SettingMedia.vue?vue&type=style&index=0&id=c4f8cab0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4f8cab0",
  null
  
)

export default component.exports